import logo from './m365.png';

const M365Logo = () => (
  <img src={typeof logo === 'string' ? logo : logo.src} id='o365-logo' className='img-responsive' alt='Logo' />
);

export default M365Logo;
